import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { BatchRecordingFormValues } from "src/models/BatchRecording.model";
import BatchRecordingForm from "../Layouts/BatchRecordingForm";
import moment from "moment";
import {
  useGetRecordingByIdQuery,
  useUpdateRecordingMutation,
} from "src/services/BatchServices";
import { useParams } from "react-router-dom";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  recordingId: string;
};

const EditBatchRecordingFormWrapper = ({ onClose, recordingId }: Props) => {
  const { batchId } = useParams();

  const [recordingData, setRecordingData] = useState<any>({});
  const { data, isFetching, isLoading } = useGetRecordingByIdQuery(recordingId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setRecordingData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  const [updateRecording] = useUpdateRecordingMutation();

  // Form Initial Values
  const initialValues: BatchRecordingFormValues = {
    date: recordingData?.date || "",
    description: recordingData?.description || "",
    fileUrl: recordingData?.fileUrl?.length
      ? recordingData?.fileUrl?.map((el: any) => {
          return {
            fileName: el,
          };
        })
      : [
          {
            fileName: "",
          },
        ],
    recordings: recordingData?.recordings?.length
      ? recordingData?.recordings?.map((el: any) => {
          return {
            title: el?.title || "",
            url: el?.url || "",
          };
        })
      : [
          {
            title: "",
            url: "",
          },
        ],
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string(),
  });

  // Handle Submit
  const handleSubmit = (
    values: BatchRecordingFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BatchRecordingFormValues>
  ) => {
    const formattedValues = {
      batchId: batchId,
      date: moment(values?.date).format("yyyy-MM-DD"),
      description: values?.description,
      fileUrl: values?.fileUrl?.map((el: any) => el["fileName"]),
      recordings: values?.recordings,
    };

    updateRecording({
        body:formattedValues ,
         id : recordingId
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          onClose();
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
             {isLoading && isFetching && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <BatchRecordingForm formikProps={formikProps} onClose={onClose}  formType='UPDATE' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditBatchRecordingFormWrapper;
